var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Content'),(_vm.$store.state.isLogged)?_c('DivChat'):_vm._e(),_c('GoTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }